"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.highcontrastTheme = void 0;
exports.highcontrastTheme = {
    logos: {
        memoresaLogoName: "logo_bright.png",
        memoresaLogotypeName: "logotype_bright.png",
    },
    type: "dark",
    background: { main: "#000000" },
    primary: { main: "#b2b2b2", contrast: "#262626" },
    secondary: { main: "#f50057", contrast: "#ffffff" },
    paper: { main: "#424242", contrast: "#f8f8f8" },
    navbar: {
        bg: "#033354",
        color: "#fff",
        hover: "#ddd",
    },
};
